




















































































































































import Vue, { PropOptions } from 'vue'
import { ProductCategory } from '@/model/productCategory'
import HeaderSection from './HeaderSection.vue'
import CategoryItem from '@/search/components/CategoryItem.vue'

import { ROUTE_NAMES } from '@/search/const'
import { MutationTypes } from '@/search/store'
import FilterItem from './FilterItem.vue'

export default Vue.extend({
  components: {
    HeaderSection,
    CategoryItem,
    FilterItem
  },
  props: {
    productCategories: {
      type: Array as () => Array<ProductCategory>,
      required: true
    },
    categorySearchCount: {
      type: Object,
      required: true
    },
    productCategoryId: {
      type: [Number, String],
      required: false,
      default: null
    } as PropOptions<number | string | null>,
    hasSearchCondition: {
      type: Boolean,
      required: true
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    toggleSection: boolean
    toggleItems: any
  } {
    return {
      toggleSection: this.open,
      toggleItems: []
    }
  },
  watch: {
    productCategoryId(value: string) {
      if (!value) {
        this.toggleItems = []
      }
    }
  },
  mounted() {
    this.searchProductCategory()
  },
  methods: {
    searchProductCategory() {
      const categoryId = Number(this.productCategoryId)
      if (categoryId && this.productCategories) {
        this.productCategories.forEach(entry1 => {
          if (entry1.id == categoryId) {
            this.toggleItems.push(entry1.id)
          } else {
            entry1.childCategories.forEach(entry2 => {
              if (entry2.id == categoryId) {
                this.toggleItems.push(entry1.id, entry2.id)
              } else {
                entry2.childCategories.forEach(entry3 => {
                  if (entry3.id == categoryId) {
                    this.toggleItems.push(entry1.id, entry2.id, entry3.id)
                  }
                })
              }
            })
          }
        })
      }
    },
    toggleSectionHandler(value: { [key: string]: boolean }) {
      this.toggleSection = value.toggle
      this.$emit('toggleSection', {
        toggle: value.toggle,
        id: MutationTypes.SET_OPEN_CATEGORY_FILTER
      })
    },
    removeAllToggle() {
      this.toggleItems = []
      this.searchCategory()
    },
    toggleCategory(key: number) {
      let i = this.toggleItems.indexOf(key)
      if (i < 0) {
        this.toggleItems.push(key)
      } else {
        this.toggleItems.splice(i, 1)
      }
    },
    searchCategory(id?: number) {
      this.$emit('onSearchCategory', id)
    },
    onChangeCategoryHandler(payload: {id: number, url: string}) {
      if (this.hasSearchCondition) {
        this.searchCategory(payload.id)
      } else {
        const categoryNames = payload.url.replace('/categories/', '').split('/')
        this.$router.push({
          name: categoryNames.length > 1 ? ROUTE_NAMES.CHILD_CATEGORY : ROUTE_NAMES.CATEGORY,
          query: this.$route.query,
          params: {
            categoryName: categoryNames[0],
            childCategory: categoryNames[1] || '',
            pageCategoryId: payload.id.toString()
          }
        })
      }
    }
  }
})
